import { Cross2Icon } from '@radix-ui/react-icons';
import { ApiError } from 'interfaces/api';
import { FC } from 'react';
import { Alert, AlertDescription, AlertTitle } from 'components/ui/alert';

export const ApiErrorAlert: FC<{
  error: ApiError | Error | undefined;
}> = ({ error, ...rest }) => {
  if (!error) {
    return null;
  }

  return (
    <Alert variant="destructive" {...rest}>
      <Cross2Icon className="h-5 w-5" />
      <AlertTitle>
        {'message' in error ? error.message : JSON.stringify(error)}
      </AlertTitle>
      {('description' in error && error.description) ||
      ('details' in error && error.details?.errors?.length) ? (
        <AlertDescription>
          {'description' in error && error.description && (
            <p className="mb-2 last:mb-0">{error.description}</p>
          )}
          {'details' in error &&
            error.details?.errors &&
            error.details.errors.length > 0 && (
              <ul className="list-disc space-y-1 pl-5">
                {error.details.errors.map((err, idx) => (
                  <li key={idx}>
                    {err.name}: {err.message}
                  </li>
                ))}
              </ul>
            )}
        </AlertDescription>
      ) : null}
    </Alert>
  );
};
